/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";






const Goto = (props) => {
    const _serviceRequestID = (props.match.params.ServiceRequestID !== undefined) ? props.match.params.ServiceRequestID : null;
   
    useEffect(() => {
        axios({
            method: 'post',
            url: "/api/v1/currentdate",
            headers: { 'referpage': '/data-analysis/request' }
        })
        .then(
            result => {

                if (_serviceRequestID != null && _serviceRequestID != '') {
                    props.history.push({
                        pathname: '/data-analysis/request',
                        state: {
                            ServiceRequestID: _serviceRequestID
                        }
                    })
                }

            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/data-analysis/id/' + _serviceRequestID
                    }
                })
            }
        );  

       


    }, [])

    return (

        <div>

       
        </div>
    );

}





export default Goto;